import React, { useEffect, useRef } from "react";
import CloseIcon from "@mui/icons-material/Close";

type Props = {
  videoUrl: string;
  onClose: () => void;
};

const CustomVideoViewer: React.FC<Props> = ({ videoUrl, onClose }) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    videoRef.current?.play();
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        zIndex: 4000,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.9)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <video
        ref={videoRef}
        src={videoUrl}
        controls
        autoPlay
        style={{
          maxWidth: "90%",
          maxHeight: "90%",
        }}
      />

      <div
        style={{
          position: "fixed",
          top: 20,
          right: 20,
          display: "flex",
          gap: 10,
        }}
      >
        <button
          className="ml-8 btn btn-primary"
          onClick={onClose}
          style={buttonStyle}
        >
          <CloseIcon />
        </button>
      </div>
    </div>
  );
};

const buttonStyle: React.CSSProperties = {
  backgroundColor: "rgba(20, 10, 154)",
  border: "none",
  color: "white",
  fontSize: 14,
  cursor: "pointer",
  padding: 8,
  borderRadius: 4,
  fontFamily: "Noto Sans",
};

export default CustomVideoViewer;
